function StopLogo() {
  const s = 7;
  const o = s / Math.sqrt(2);
  const i = 5;
  const l = i / Math.sqrt(2);
  const h = o + (s / 2);
  return (
    <svg className="status warning" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          id="border"
          style={{ fill: 'white', stroke: 'red', strokeWidth: 4, vectorEffect: 'non-scaling-stroke' }}
          d={`m${h + 4} ${h - o - (s / 2) + 4}h${s/2}l${o} ${o}v${s}l${-o} ${o}h${-s}l${-o} ${-o}v${-s}l${o} ${-o}h${s/2}`}
        />
        <path
          id="fill"
          style={{ fill: 'none', stroke: 'white', strokeWidth: 3, vectorEffect: 'non-scaling-stroke' }}
          d={`m${h+ 4} ${h - l - (i / 2) + 4}h${i/2}l${l} ${l}v${i}l${-l} ${l}h${-i}l${-l} ${-l}v${-i}l${l} ${-l}h${i/2}`}
        />
      </g>
    </svg>
  );
}

export default StopLogo;
